import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router";
import Header from "./Header";
import Footer from "../Footer";
import fire from "./Firebase";
import "../App.css";

function CertificateTemp3() {
  document.title = "HR School-Template 3";
  const conponentPDF = useRef();
  const [temp3, settemp3] = useState({});
  useEffect(() => {
    fire.child("certificates").on("value", (data) => {
      if (data.val() == null || data.val() == "") alert("Data Fetch");
      else {
        settemp3(data.val());
      }
      console.log(data.val());
    });
  }, []);
  const navigate = useNavigate();
  function generatePDF(keys) {
    sessionStorage.setItem("lastname3", keys);
    navigate("/try3");
  }
  return (
    <>
      <Header />
      <div>
        <center>
          {" "}
          <h1>Download PDF Certificate</h1>
        </center>
        <div id="maindiv" ref={conponentPDF}>
          {Object.keys(temp3).map((all, index) => {
            return (
              <>
                <div id="temp3" style={{textTransform:"uppercase"}}>
                  <div className="certicontainer">
                    <div className="certititle">HR SCHOOL</div>
                    <div className="certititle">CERTIFICATE OF COMPLETION</div>
                    <div className="certiline"></div>
                    <div className="certicourse-title">
                      CERTIFIED {temp3[all].Field} SPECIALIST
                    </div>
                    <div className="certihours-value">
                      THIS IS TO CERTIFY THAT
                    </div>
                    <div className="certihours">NAME :- {temp3[all].Gender} {temp3[all].Name}</div>
                    <div className="certihours">
                      FATHER NAME :- {temp3[all].Father}
                    </div>
                    <div className="certihours">
                      COURSE DURATION :- {temp3[all].Course} MONTHS
                    </div>
                    <div className="certihours">
                      COURSE NAME :- {temp3[all].Coursename}
                    </div>
                    <div className="certitext-bold">
                      THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN TAKE
                      IT AWAY FROM YOU.
                    </div>
                    <div className="certitext">
                      HAS SUCCESSFULLY COMPLETED THE {temp3[all].Coursename}{" "}
                      COURSE WITH LOKI SCHOOL
                    </div>
                    <div className="certismall-line"></div>
                    <div className="certisubtitle">
                      WITH SCORE OF {temp3[all].grade}
                    </div>
                    <div className="certismall-line"></div>
                    <div className="certisubtitle">Date</div>
                    <div className="certisubtitle">
                      START DATE :- {temp3[all].startdate}/{temp3[all].startmonth}/{temp3[all].startyear}
                    </div>
                    <div className="certisubtitle">
                      END DATE :-{temp3[all].enddate} /
                        {temp3[all].endmonth}/{temp3[all].endyear}
                    </div>
                    <div className="certisubtitle">www.hrschool.com</div>
                  </div>
                </div>
                <center>
                  {" "}
                  <br />
                  <button onClick={() => generatePDF(all)}>
                  Download {temp3[all].Name} Image
                  </button>
                </center>
              </>
            );
          })}
        </div>
      </div>{" "}
      <br />
      <br />
      <Footer />
    </>
  );
}

export default CertificateTemp3;
